export const TERMS_VERSION = 'beta-terms-2026-09-02-v2';
export const PRIVACY_VERSION = 'beta-privacy-2026-09-02-v2';
